<template>
  <div class="ts-space-y-5" style="height:250px">
    <div class="ts-border ts-border-gray-300 ts-p-3 ts-rounded-md ts-mt-6">
      <h3 class="ts-text-base ts-font-heading-font ts-text-blue-600">
        <span class="ts-text-gray-700">{{ receiver }}</span>
        {{ ' : ' + phone_number }}
      </h3>
      <small class="validate" v-if="errors.has('customer_id')">{{ errors.first('customer_id') }}</small>
      <h3 class="ts-text-base ts-font-heading-font ts-text-blue-600">
        <span class="ts-text-gray-700">{{ amount }}</span>
        {{ ' : '+ model.amount }}
      </h3>
      <small class="validate" v-if="errors.has('amount')">{{ errors.first('amount') }}</small>
    </div>
    <input 
			v-model="model.password" 
			type="password" 
			:placeholder="placeholder" 
			class="form-control"
			:class="{ 'is-invalid': errors.has('password') }" 
		/>
    <div class="invalid-feedback" v-if="errors.has('password')">{{ errors.first('password') }}</div>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'confirmResult',
  props: [
    'value',
    'validate',
    'placeholder',
    'receiver',
    'amount',
    'phone_number'
  ],
  data() {
    return {
      model: {},
      errors: new Errors()
    }
  },
  created() {
    this.model = this.value
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
